import Management from '@/screens/management'
import IncomeReport from '@/screens/management/IncomeReport'
import PurchaseReport from '@/screens/management/PurchaseReport'
import ExpensesReport from '@/screens/management/ExpensesReport'
import ResultReport from '@/screens/management/ResultReport'
import auth from './middleware/auth'
import store from '@/store'

const routes = [
  {
    path: '/management',
    name: 'Management',
    component: {
      ...Management,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Management') {
          const routes = {
            manager: 'IncomeReport'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Management') {
          const routes = {
            manager: 'IncomeReport'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        name: 'IncomeReport',
        path: '/income-report',
        component: IncomeReport,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        name: 'PurchaseReport',
        path: '/purchase-report',
        component: PurchaseReport,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        name: 'ExpensesReport',
        path: '/expenses-report',
        component: ExpensesReport,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        name: 'ResultReport',
        path: '/result-report',
        component: ResultReport,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
